import { render } from "./ContactQuestion.vue?vue&type=template&id=6ba7d122&scoped=true"
import script from "./ContactQuestion.vue?vue&type=script&lang=js"
export * from "./ContactQuestion.vue?vue&type=script&lang=js"

import "./ContactQuestion.vue?vue&type=style&index=0&id=6ba7d122&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba7d122"]])

export default __exports__